<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading :active.sync="loader"></loading>
    <b-row>
      <b-col>
        <b-row>
          <b-col cols="4">
            <b-form-group align="left">
              <label for="nombreBusq">Año</label>
              <v-select name="clinica" placeholder="Seleccionar año"
                        v-model="filtro.anio" :options="anios"
              >
              </v-select>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group align="left">
              <label for="nombreBusq">Mes</label>
              <v-select name="clinica" placeholder="Seleccionar mes"
                        v-model="filtro.mes" :options="meses" label="text" :reduce="(val) => val.value"
              ></v-select>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group align="left">
              <label>Periodo</label>
              <b-form-radio v-model="filtro.periodo" name="some-radios" value="2">Primera quincena con BIP sin BMR
              </b-form-radio>
              <b-form-radio v-model="filtro.periodo" name="some-radios" value="1">Mensual con BMR y BIP</b-form-radio>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group align="center">
              <p class="text-info">Este proceso puede demorar unos minutos</p>
              <b-button variant="primary" v-on:click="obtenerDatos">Descargar</b-button>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <hr/>
  </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import * as JSZip from "jszip";
import {saveAs} from "file-saver";

export default {
  name: "Layout",
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      loader: false,
      anios: [],
      meses: [
        {value: 1, text: "Enero"},
        {value: 2, text: "Febrero"},
        {value: 3, text: "Marzo"},
        {value: 4, text: "Abril"},
        {value: 5, text: "Mayo"},
        {value: 6, text: "Junio"},
        {value: 7, text: "Julio"},
        {value: 8, text: "Agosto"},
        {value: 9, text: "Septiembre"},
        {value: 10, text: "Octubre"},
        {value: 11, text: "Noviembre"},
        {value: 12, text: "Diciembre"},
      ],
      filtro: {
        periodo: null,
        anio: null,
        mes: null,
        quincena: null,
        fechaInicio: null,
        fechaFin: null,
        fechaBrm: null,
      },
    }
  },
  validations: {
    filtro: {
      fechaInicio: {required},
      fechaFinal: {required},
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    const anioInicio = 2021;
    const anioActual = this.$moment().year();

    this.anios = [];
    for (let anio=anioInicio; anio <= anioActual; anio++) {
      this.anios.push(anio);
    }

    this.anios
  },
  methods: {
    saveXLSX(datos) {
      const zip = new JSZip();
      zip.file("layout.xlsx", datos, {base64: true});
      zip.generateAsync({type: "blob"}).then(function (content) {
        saveAs(content, "layout.zip");
      });
    },
    obteneFechas() {
      if (this.filtro.periodo === '1') {
        this.filtro.fechaInicio = this.$moment(this.filtro.anio+"-"+this.filtro.mes+"-16").utc();
        this.filtro.fechaFin = this.$moment(this.filtro.anio+"-"+this.filtro.mes+"-01").add(1, "month").add(-1, "day").utc();

        this.filtro.fechaBrmInicio = this.$moment().utc(); // NO SE USA
        this.filtro.fechaBrmFin = this.$moment().utc(); // NO SE USA

        this.filtro.includeBrm = false;

      } else {
        this.filtro.fechaInicio = this.$moment(this.filtro.anio+"-"+this.filtro.mes+"-01").utc();
        this.filtro.fechaFin = this.$moment(this.filtro.anio+"-"+this.filtro.mes+"-15").utc();

        this.filtro.fechaBrmInicio = this.$moment(this.filtro.anio+"-"+this.filtro.mes+"-01").utc();
        this.filtro.fechaBrmFin = this.$moment(this.filtro.anio+"-"+this.filtro.mes+"-01").add(1, "month").add(-1, "day").utc();

        this.filtro.includeBrm = true;

      }

    },
    obtenerDatos() {
      this.loader = true;
      this.obteneFechas();
      const envio = {
        fechaInicio: this.$moment(this.filtro.fechaInicio)
            .utc()
            .format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
        fechaFinal: this.$moment(this.filtro.fechaFin)
            .utc()
            .format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
        fechaBrmInicio: this.$moment(this.filtro.fechaBrmInicio)
            .utc()
            .format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
        fechaBrmFin: this.$moment(this.filtro.fechaBrmFin)
            .utc()
            .format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
        includeBrm: this.filtro.includeBrm,
        horas: this.$horas(),
      };
      this.$http
          .post(this.$api + "comisiones/comisiones/layout", envio)
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.saveXLSX(respuesta.data.data)
            }
          })
          .finally(() => {
            this.loader = false;
          });
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.filtro[name];
      return $dirty ? !$error : null;
    },
    filterTable(row, filter) {
      return parseInt(row.idEmpleado) === parseInt(filter)
          || row.empleado.toLowerCase().search(filter.toLowerCase()) !== -1

    }
  }
}
</script>

<style scoped>

</style>
